// src/components/LanguageSwitcher.jsx
// Dropdown pilihan bahasa untuk header
import { useState, useRef, useEffect } from "react";
import { useLanguage } from "../context/LanguageContext";
import { LANGUAGES } from "../data/translations";

export default function LanguageSwitcher() {
  const { lang, changeLang } = useLanguage();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  const current = LANGUAGES.find(l => l.code === lang) || LANGUAGES[0];

  // Tutup dropdown bila klik luar
  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  return (
    <div ref={ref} style={{ position: "relative" }}>
      <button
        onClick={() => setOpen(o => !o)}
        style={{
          display: "flex", alignItems: "center", gap: 6,
          background: "#13131a", border: "1px solid #2a2a3a", borderRadius: 10,
          padding: "6px 10px", cursor: "pointer", color: "#e8e8f0",
          fontSize: 13, fontFamily: "inherit", fontWeight: 600,
        }}
      >
        <span style={{ fontSize: 15 }}>{current.flag}</span>
        <span>{current.short}</span>
        <span style={{ fontSize: 9, color: "#666" }}>▼</span>
      </button>

      {open && (
        <div style={{
          position: "absolute", top: "calc(100% + 6px)", right: 0,
          background: "#13131a", border: "1px solid #2a2a3a", borderRadius: 12,
          padding: 6, minWidth: 170, zIndex: 200,
          boxShadow: "0 8px 24px rgba(0,0,0,0.5)",
        }}>
          {LANGUAGES.map(l => (
            <button
              key={l.code}
              onClick={() => { changeLang(l.code); setOpen(false); }}
              style={{
                display: "flex", alignItems: "center", gap: 10, width: "100%",
                background: l.code === lang ? "rgba(99,102,241,0.15)" : "transparent",
                border: "none", borderRadius: 8, padding: "9px 12px",
                cursor: "pointer", color: l.code === lang ? "#a5b4fc" : "#e8e8f0",
                fontSize: 14, fontFamily: "inherit", textAlign: "left",
                fontWeight: l.code === lang ? 600 : 400,
              }}
              onMouseEnter={e => { if (l.code !== lang) e.currentTarget.style.background = "#1e1e2e"; }}
              onMouseLeave={e => { if (l.code !== lang) e.currentTarget.style.background = "transparent"; }}
            >
              <span style={{ fontSize: 17 }}>{l.flag}</span>
              <span>{l.label}</span>
              {l.code === lang && <span style={{ marginLeft: "auto", fontSize: 12 }}>✓</span>}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}